module.exports = __webpack_public_path__ + "9ce80e8f9dfaf0845eee39658b8f4120.svg";